export default defineNuxtPlugin((nuxtApp) => {
  const capturedError = ref<any>(null)

  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.log('!!!Captured Error:', error)
    capturedError.value = error || {}
  }

  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.log('!!!Captured Error:', error)
    capturedError.value = error || {}
  })

  return {
    provide: {
      globalerror: capturedError,
    },
  }
})
